import React, { useState } from 'react';
import { Query } from 'react-apollo';
import styled from 'react-emotion';
import { useLocation } from 'react-router-dom';
import Spinner from '../../ui/Spinner';
import { SharedCartBuyAllButton } from './SharedCartBuyAllButton';
import { SharedCartProduct } from './SharedCartProduct';
import SharedCartQuery from './SharedCartQuery.gql';

const SharedCartContainer = styled('div')`
  display: grid;
  grid-template-columns: 1fr;
  place-items: center;
  margin: 0 auto;
  padding: 32px 8px;
  max-width: 800px;
  ${({ theme }) => theme.above.md} {
    padding: 32px;
  }
`;

const Header = styled('h1')`
  line-height: normal;
  font-size: 32px;
  margin-bottom: 10px;
  text-align: center;
`;
const SubHeader = styled('h2')`
  line-height: normal;
  font-size: 24px;
  margin-bottom: 10px;
  text-align: center;
`;

const SharedItems = styled('section')`
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.5rem;
`;

const ActionWrapper = styled('div')`
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.5rem;
`;

function addQuantity(products, params) {
  try {
    const productsWithQuantity = products?.map((product) => {
      const [_, quantity] = params?.find((param) => {
        return product?.articleNumber === param[0];
      });

      return {
        ...product,
        quantity: parseInt(quantity),
      };
    });

    return productsWithQuantity;
  } catch (e) {
    console.log('Error adding quantity to products\n', e);
    return products;
  }
}

export const SharedCartPage = ({ category }) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const artNoParams = queryParams.getAll('artNo') || [];
  const splitParams = artNoParams.map((param) => param.split('$'));
  const articleNumbers = splitParams.map((param) => param[0]);

  const [quantities, setQuantities] = useState(
    Array.from({ length: splitParams.length }, () => 1)
  );

  return (
    <SharedCartContainer>
      <Header data-testid="category-title">
        {category.name.replaceAll('=', '')}
      </Header>
      <SubHeader data-testid="category-title">
        Välkommen till din delade varukorg. Här kan du lägga till de sparade
        artiklarna i din befintliga varukorg.
      </SubHeader>
      <Query
        query={SharedCartQuery}
        variables={{ articleNumbers: articleNumbers }}
        onCompleted={(data) => {
          const products = data?.products || [];
          const productsWithQuantity = addQuantity(products, splitParams);
          setQuantities(
            productsWithQuantity.map((p) => (p.quantity > 0 ? p.quantity : 1))
          );
        }}
      >
        {({ loading, error, data }) => {
          if (loading) return <Spinner />;
          if (error) {
            console.warn(error);
            return `Inga produkter i delad kundvagn`;
          }

          const products = data?.products || [];
          const productsWithQuantity = addQuantity(products, splitParams);

          return (
            <ActionWrapper>
              <SharedCartBuyAllButton
                products={productsWithQuantity}
                quantities={quantities}
              />
              <SharedItems data-testid="shared-item-wrapper">
                {productsWithQuantity?.map((product, i) => {
                  return (
                    <SharedCartProduct
                      key={product.id}
                      product={product}
                      quantity={quantities[i]}
                      incQuantity={() =>
                        setQuantities((prev) => {
                          const newQuantities = [...prev];
                          newQuantities[i] += 1;
                          return newQuantities;
                        })
                      }
                      decQuantity={() =>
                        setQuantities((prev) => {
                          const newQuantities = [...prev];
                          if (newQuantities[i] === 1) return newQuantities;
                          // Decrease quantity only if it's greater than 1
                          newQuantities[i] -= 1;
                          return newQuantities;
                        })
                      }
                    />
                  );
                })}
              </SharedItems>
            </ActionWrapper>
          );
        }}
      </Query>
    </SharedCartContainer>
  );
};
